import LayoutMain from './../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../ProgressHUD/index.vue'
import CompanyInfo from './../Permissions/Roles/BaseComponents/CompanyInfo/index.vue'
import Api from './../../../services/api'

export default {
  name: 'RegisterMyCompany',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    CompanyInfo,
  },
  data() {
    return {
      validationMessage: '',
    }
  },
  methods: {
    setHeightImage() {
      var pic_box = $('.picture-box')
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight
        pic_box[0].style.height =
          (h > screen.availHeight ? h - 80 : screen.availHeight - 80) + 'px'
      }
    },

    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },

    async save() {
      try {
        let isValidCompanyInfo = await this.$refs.companyInfo.isValid()

        if (!isValidCompanyInfo) {
          this.$toast.error({
            title: 'Error',
            message: 'The entered data is not valid',
            color: '#a21010',
          })

          return
        }

        this.$refs.progress.show()

        var requestData = this.$refs.companyInfo.getData()
        var response = await Api.setCompany(requestData)
        console.log(response)

        this.$refs.progress.hide()

        this.$toast.success({
            title: 'Success!',
            message: 'Company successfully saved. Please confirm by email.',
        })

        this.$router.push('/dashboard')
      } catch (error) {
        console.error(error)
        this.$toast.error({
          title: 'Error',
          message: error.message,
          color: '#a21010',
        })
      } finally {
        this.$refs.progress.hide()
      }
    },
  },
  async created() {
    try {
      var response = await Api.myProfile()
      this.$refs.companyInfo.setData(response.data.results.company)


    } catch (error) {
      console.error(error)
      this.$toast.error({
        title: 'Error',
        message: error.message,
        color: '#a21010',
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
  mounted() {
    this.setHeightImage()
    window.addEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Account/RegisterMyCompany/RegisterMyCompany.component.js